import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { format } from "date-fns";

interface MonitoringTrendsProps {
  profile: any;
  readings: any[];
}

export function MonitoringTrends({ profile, readings }: MonitoringTrendsProps) {
  const parameters = (profile.parameters as any[]) || [];
  
  if (readings.length === 0) {
    return null;
  }

  // Transform readings data for charts
  const chartData = readings.map((reading) => {
    const data: any = {
      time: format(new Date(reading.recorded_at), 'MMM dd HH:mm'),
    };
    
    (reading.readings as any[])?.forEach((r: any) => {
      data[r.name] = r.value;
    });
    
    return data;
  }).reverse(); // Reverse to show oldest first

  const colors = ['hsl(var(--chart-1))', 'hsl(var(--chart-2))', 'hsl(var(--chart-3))', 'hsl(var(--chart-4))', 'hsl(var(--chart-5))'];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Trends</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="time" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip />
            <Legend />
            {parameters.map((param: any, index: number) => (
              <Line
                key={param.name}
                type="monotone"
                dataKey={param.name}
                stroke={colors[index % colors.length]}
                strokeWidth={2}
                dot={{ r: 4 }}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
